// Copyright © 2024 Broadcom Inc. and its subsidiaries. All Rights Reserved.
import { isEmail } from 'validator';

export const ACTIONS = {
  UPDATE_FIELD_VALUE: 'UPDATE_FIELD_VALUE',
  UPDATE_FIELD_ERRORS: 'UPDATE_FIELD_ERRORS',
  UPDATE_FORM_ERRORS: 'UPDATE_FORM_ERRORS',
  UPDATE_FORM_VALUES: 'UPDATE_FORM_VALUES',
}

const allFields = ['adminEmail', 'trackingId'];

export const settingsReducer = (state, action) => {
  switch (action.type) {
    case ACTIONS.UPDATE_FIELD_VALUE: {
      const { field, value } = action.payload;
      const updatedState = { ...state, [field]: { ...state[field], value } };
      return updatedState;
    }

    case ACTIONS.UPDATE_FIELD_ERRORS: {
      const { field, intl } = action.payload;
      const value = state[field].value;
      const errors = validateField({
        field, value, intl,
      });
      const updatedState = { ...state, [field]: { value, errors } };
      return updatedState;
    }

    case ACTIONS.UPDATE_FORM_ERRORS: {
      return action.payload.reduce((acc, curr) => {
        acc[curr.field] = { value: curr.value, errors: curr.errors }
        return acc;
      }, {});
    }

    case ACTIONS.UPDATE_FORM_VALUES: {
      const { data, intl } = action.payload;
      const updatedState = { ...state };

      allFields.forEach(field => {
        if (data[field]) {
          updatedState[field].value = data[field]
        }
      });

      allFields.forEach(field => {
        if (data[field]) {
          updatedState[field].errors = validateField({
            field, value: data[field], intl,
          });
        }
      });

      return updatedState;
    }

    default: {
      throw Error('Unknown action: ' + action.type);
    }
  }
}

export const initializeSettingsState = () => {
  return {
    adminEmail: { value: '', errors: [] },
    trackingId: { value: '', errors: [] },
  }
};

const validateField = ({ field, value, intl }) => {
  const errors = [];

  if (field === 'adminEmail' && !isEmail(value)) {
    errors.push(intl.getI18nMessage("label.user.profile.email.format.error"));
  }

  if (field === 'trackingId') {
    const regex = new RegExp("^UA-[a-zA-Z0-9]{1,10}(-[a-zA-Z0-9]{1,4})?$");
    if (value && !regex.test(value)) {
      errors.push(intl.getI18nMessage("label.portal.setup.google-analytics.error"));
    }
  }

  return errors;
}

export const validateFormInputs = ({ state, intl }) => {
  let isFormValid = true;
  const validatedState = allFields.map(field => {
    const fieldErrors = validateField({
      field, value: state[field].value, intl,
    });
    if (fieldErrors.length > 0) {
      isFormValid = false;
    }
    return { field, value: state[field].value, errors: fieldErrors }
  })
  return { validatedState, isFormValid };
}
